import React from 'react';

const ProgressBar = props => {
    const { bgcolor, completed } = props;

    const containerStyles = {
        height: 5,
        width: '100%',
        maxWidth: '100%',
        backgroundColor: '#e0e0de',
        borderRadius: 50,
        margin: '5px 0px',
    };

    const fillerStyles = {
        height: '100%',
        width: `${completed}%`,
        maxWidth: '100%',
        transition: 'width 1s ease-in-out',
        borderRadius: 'inherit',
        textAlign: 'right',
    };

    const labelStyles = {
        padding: 5,
        color: 'white',
        fontWeight: 'bold',
    };

    return (
        <div className="progress-bar-container" style={containerStyles}>
            <div className="progress-bar-fill" style={fillerStyles}>
                {/* <span style={labelStyles}>{`${completed}%`}</span> */}
            </div>
        </div>
    );
};

export default ProgressBar;
